import { render } from "./ArrowBoxLeftIcon.vue?vue&type=template&id=16b737b3"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__